<template>
  <div>
    <v-btn
      color="pewter"
      hide-details
      class="ml-2 mr-2"
      :title="buttonTitle"
      :disabled="generating"
      :loading="generating"
      @click="generatePdf"
    >
      Generate PDF
    </v-btn>

    <v-btn
      v-if="(lastUpdatePdf && lastUpdatePdf !== 'Never') || currentGeneratedTime"
      color="pewter"
      hide-details
      class="mr-2"
      :disabled="generating"
      @click="downloadPdf"
    >
      Download PDF
    </v-btn>
    
  </div>
</template>

<script>
import axios from 'axios'
import Cookie from 'js-cookie';
import dateformat from 'dateformat'

import appUrls from '../../helpers/environment'

export default {
  name: 'GeneratePdfOfListing',

  props: {
    listingId: String,
    lastUpdatePdf: String,
  },

  data: () => ({
    generating: false,
    currentGeneratedTime: '',
  }),

  computed: {
    buttonTitle () {
      const time = this.currentGeneratedTime || this.lastUpdatePdf
      return `Last Generated: ${time ? dateformat(time) : 'Never'}`
    },
  },

  methods: {
    async generatePdf () {
      this.generating = true

      try {
        const data = await axios.get(`${appUrls.api}/api/admin/generate_listing_pdf/${this.listingId}`, {
          headers: { 
            authentication: Cookie.get('token'), 
            'Content-Type': 'application/json',
          },
        })

        this.currentGeneratedTime = dateformat(new Date())

        this.$feedback.success( 'Generated the PDF and saved it to S3' )
      } catch (err) {
        this.$feedback.error( `There was a problem generating the PDF. ${err.message}` )

        console.error('Failed to generate PDF', err)
      }

      this.generating = false
    },

    downloadPdf () {
      window.open(`${appUrls.api}/api/listing-details-pdf/${this.listingId}`)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/partials/generatePdfOfListing.vue